import classNames from 'classnames';
import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { useAccount } from '../../fetchHooks/useAccount';
import useAccountId from '../../hooks/queryparams/useAccountId';
import TransactionTabs from './TransactionTabs';
import Transactions from './Transactions';

import './TransactionList.scss';

interface Props {
    isLoanView?: boolean;
    accountType?: string;
    setNoAccessToAccountException?: React.Dispatch<React.SetStateAction<RequestExceptionWithResponse | undefined>>;
}

const TransactionListPage: React.FC<Props> = ({ setNoAccessToAccountException, isLoanView, accountType }) => {
    const accountId = useAccountId();

    const { data: account, ...accountStatus } = useAccount(accountId);

    const isLoanOrBSU = isLoanView || account?.type === 'BSU';

    return (
        <div className={classNames('transaction-list-widget', { 'without-future-payments': isLoanOrBSU })}>
            {accountId && (
                <>
                    {isLoanView ? (
                        <Transactions
                            setNoAccessToAccountException={setNoAccessToAccountException}
                            account={account}
                            accountId={accountId}
                            isLoanView
                        />
                    ) : (
                        <TransactionTabs
                            setNoAccessToAccountException={setNoAccessToAccountException}
                            isLoading={accountStatus.isLoading}
                            accountId={accountId}
                            accountType={accountType}
                            account={account}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default TransactionListPage;
